/* @flow */
import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import * as LocationApi from 'api/Location/LocationApi';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import endpoints from 'api/endpoints';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  location: Object,
  form: TypeForm,
  companyId: string,
  countryId: string,
|} & TranslatorProps;

@translate()
@observer
export default class RemoveUsersForm extends React.Component<*> {
  render(): React.Node {
    const { t, form, location }: TypeProps = this.props;

    const user: Object = JSON.parse(localStorage.getItem('user'));

    const details: Array<Array> = [[t('general:company'), location.company.name]];

    if (location.hierarchy) {
      if (location.hierarchy.site) {
        if (location.hierarchy.site.name) {
          details.push([t('general:locations.labels.site'), location.hierarchy.site.name]);
        }

        if (location.hierarchy.site.address) {
          details.push([
            t('general:locations.labels.site_address'),
            <SiteAddress key="site_address" {...location.hierarchy.site.address} />,
          ]);
        }
      }

      if (location.hierarchy.building && location.hierarchy.building.name) {
        details.push([
          t('general:locations.labels.building_transport'),
          location.hierarchy.building.name,
        ]);
      }

      if (location.hierarchy.room && location.hierarchy.room.name) {
        details.push([t('general:locations.labels.lab_room'), location.hierarchy.room.name]);
      }

      if (location.hierarchy.workspace && location.hierarchy.workspace.name) {
        details.push([
          t('general:locations.labels.system_workspace'),
          location.hierarchy.workspace.name,
        ]);
      }
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:locations.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('removeUsers.users')}
            heading={form.$('removeUsers').label}
            endpoint={`locations/${location.id}/users`}
            enableSearch={true}
            searchKeys={['first_name', 'last_name']}
            primaryLiteral={(item: Object) => {
              return item.id === user.id ? (
                <React.Fragment>
                  <strong>Me</strong>&nbsp;({`${item.first_name} ${item.last_name}`})
                </React.Fragment>
              ) : (
                `${item.first_name} ${item.last_name}`
              );
            }}
            secondaryLiteral={(item: Object) => (
              <React.Fragment>
                Current role: <strong>{`${item.role}`}</strong>
              </React.Fragment>
            )}
          />
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.remove_users')} />
      </React.Fragment>
    );
  }
}
